<div class="footerContainer">
  <div class="container" style="width: 100%;padding-top: 20px;padding-bottom: 20px">
    <app-motion-background></app-motion-background>
    <div class="row" style="max-width: 100%">
      <div class="col-xl-2 col-lg-2 col-md-2  col-sm-2 col-12  info row">
        <img src="./assets/images/login/logo.png" width="45px" height="45px" />
      </div>
      <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
        <div class="row">
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12" style="padding: 0">
            <ul>
              <li [routerLink]="['/index/terms-conditions/',lang]">
                {{'LOGIN.OUR_TERMS_AND_CONDITIONS' | translate}}
              </li>
              <li [routerLink]="['/index/privacy-policy/',lang]">{{'LOGIN.PRIVACY_POLICY' | translate}}</li>
            </ul>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 links">
            <span>{{ "LOGIN.FOLLOW_US" | translate }}</span>
            <ul>
              <li>
                <a target="_blank" href="https://www.facebook.com/www.5dma.vip/">
                  <img class="social" style="object-fit: contain" src="assets/images/login/facebook.png"
                    alt="facebook" />{{ "LOGIN.FACEBOOK_LINK" | translate }}
                </a>
              </li>
              <li>
                <a target="_blank" href="https://www.youtube.com/channel/UCEtfKhbDWs9rUF3UGj6eiLw">
                  <img class="social" src="assets/images/login/youtube.png" alt="youtube" />{{
                  "LOGIN.YOUTUBE_LINK" | translate
                  }}
                </a>
              </li>
              <li>
                <a target="_blank" href="https://www.instagram.com/5dma.vip">
                  <img class="social" src="assets/images/login/instagram.png" alt="instagram" />{{
                  "LOGIN.INSTGRAM_LINK" | translate
                  }}
                </a>
              </li>
              <li>
                <a target="_blank" href="https://linkedin.com/company/global-digitaluniverse">
                  <img class="social" src="assets/images/login/linkedin.png" alt="linkedin" />{{
                  "LOGIN.Linkedin_LINK" | translate
                  }}
                </a>
              </li>
              <li>
                <a target="_blank" href="https://x.com/5dmaVip">
                  <img class="social" src="assets/images/login/twitter.png" alt="twitter" />{{
                  "LOGIN.TWITTER_LINK" | translate
                  }}
                </a>
              </li>
              <li>
                <a target="_blank" href="https://www.tiktok.com/@5dma.vip">
                  <img class="social" src="assets/images/login/tik-tok.png" alt="tik-tok" />{{
                  "LOGIN.TIKTOK_LINK" | translate
                  }}
                </a>
              </li>
            </ul>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 contact">
            <span>{{ "LOGIN.CONTACTS" | translate }}</span>
            <ul>

              <li style="width: 200px; display: flex; align-items: center;">
                <img class="social" src="assets/images/login/mail.png" alt="mail" />
                info&#64;5dma.vip'
              </li>
              <li style="width: 200px; display: flex; align-items: center;">
                <img class="social" src="assets/images/login/phone.png" alt="phone" />
                00966576093104
              </li>
            </ul>
          </div>
        </div>

      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 stores-container">
        <ul>
          <li (click)="openStoreDialog('googlePlay')">
            <img class="store" src="assets/images/googleplay.png" alt="googleplay" />
          </li>
          <li (click)="openStoreDialog('appStore')">
            <img class="store" src="assets/images/appstore.png" alt="appstore" />
          </li>
          <li (click)="openStoreDialog('appGallery')">
            <img class="store" src="assets/images/appgallery.png" alt="appgallery" />
          </li>
        </ul>
      </div>
    </div>
    <p style="text-align: center">5dma.vip {{ "LOGIN.LOGIN_FOOTER_DESC" | translate }}</p>
  </div>
  <div class="copy-rights"><img style="width: 30px" src="./assets/images/digitalLogo.png" /><span>{{"LOGIN.COPYRIGHTS" |
      translate}}</span>
  </div>
</div>